import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { Link, Tooltip } from '@mui/material';
import { useTheme } from 'styled-components';
import { useRegisterForm } from '../../context';
import { UserController } from '../../controller/UserController';
import { DropZone } from '../DropZone';
import { UserProfilePicture } from '../UserProfilePicture';
import { ProfileVerified } from '../Verified';
import { Container } from './styles';

export function FeedProfilePicture() {
  const theme = useTheme();
  const { firstName, isVerified, pictureProfile, setPictureProfile, linkSite } = useRegisterForm();
  return (
    <Container>
      <div className="containerProfilePicture">
        <div className="contentProfilePicture">
          <UserProfilePicture pictureId={pictureProfile?.id} isFeedPicture />
        </div>
        <div className="containerChangePicture">
          <DropZone
            multipleFiles={false}
            renderType="button"
            type="picture"
            onFile={({ file }) => {
              setPictureProfile(file);
            }}
            onRemoveFile={() => setPictureProfile(undefined)}
            defaultValues={pictureProfile?.file}
            uploadHandler={UserController.updateProfilePicture}
            fileId={pictureProfile?.id}
            iconButtonRender={<AddAPhotoIcon style={{ color: theme.colors.tertiary_500 }} />}
            isUploadOnDrop
            renderSummary={false}
            showButtonForUpload
          />
        </div>
      </div>
      <div className="contentDataUser">
        <div className="nameUser">
          <Tooltip disableInteractive title={firstName}>
            <h1>{firstName}</h1>
          </Tooltip>
          <h1>{isVerified && <ProfileVerified color="tertiary_500" />}</h1>
        </div>
        {linkSite && (
          <Link
            href={`https://${linkSite.replace('https://', '').replace('http://', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            referrerPolicy="no-referrer">
            {linkSite?.split('//')?.[1] ?? 'Acessar site'}
          </Link>
        )}
      </div>
    </Container>
  );
}
